<hr style="width: 100%" class="header-border" />
<div class="container">
    <div class="row">
        <div class="col-md-12">
            <ul class="p-0" id="homeRoutes">
                <li *ngFor="let route of routes" class="list-names">
                    <a [routerLink]="route.url" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                        {{ route.linkName }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>
<div class="pb-150">
    <router-outlet></router-outlet>
</div>
